<div class="spend-chart-summary">
  <ng-content></ng-content>
</div>
